import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => <ScreenRedirect to="/jira/settings/system/general-configuration" />;
